import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericAutoCompleteProperties } from './generic-autocomplete-properties';
import { WrapperStandardFilter, WrapperStandardRequest } from '../../common/models/wrapper.model';
import { GenericService } from '../../services/base/generic-service';
import { Router } from '@angular/router';

@Component({
    template: ''
})
export class GenericAutoCompleteFunctions<T> extends GenericAutoCompleteProperties<T>{

    constructor(genericService: GenericService<T>, router: Router) {
        super(genericService, router);
    }
    async OnClickOptionsList() {
        this.setListViewDataSourceURL = this.getACDataSourceURL;
        this.getRequestData.SortColumn = this.getACSortColumn;
        this.getRequestData.PageRecordCount=1000;
        
        await this.PopulateListView();
        return this.getListViewDataSource;
    }
}